import * as React from 'react';
import {styled} from '../../../utils';
import Sider from '../Sider';
import {WrapperProps} from './types';

const Root = styled('div')<WrapperProps>(({hasSider}) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: hasSider ? 'row' : 'column',
  flex: 1,
  flexBasis: 'auto',
  minHeight: 0
}));

export default class Wrapper extends React.Component<WrapperProps, {}> {
  public render() {
    let hasSider = false;

    React.Children.forEach(this.props.children, child => {
      if (React.isValidElement(child) && child.type === Sider) {
        hasSider = true;
      }
    });

    return <Root {...this.props} hasSider={this.props.hasSider || hasSider} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Wrapper/Wrapper.tsx